import styles from './styles.module.scss'

type PageBannerProps = {
  text: string
}

const PageBanner: React.FC<PageBannerProps> = ({ text }) => (
  <div className={styles['th-news-banner']}>
    <h1 className={styles['th-banner-title']}>{text}</h1>
  </div>
)

export default PageBanner
